import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import { ProgramStore } from 'stores';
import '../client/temp-common-imports';

export class ProgramsController implements Controller {
  public pageId = 'Programs';
  public path = '/:localeName/programs';
  public routeName = 'programs';
  public bundles = [];

  public exact = true;

  public component = codeSplit(() => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/programs-page'));

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    const { stores, query } = options;

    const programs: ProgramStore = stores && stores.get<ProgramStore>('programs');

    // check for program live override
    if (query.showProgram) {
      programs.setForcedLive(query.showProgram);
    }

    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'Affiliate Hub Programs' }) as Promise<PageData>;
  }
}
